import React from 'react';
const configurationContext = React.createContext({});
export default configurationContext;
